import styled from "styled-components";

export const NotificationWidgetStyled = styled.div`
  .btn_notification {
    padding: 4px 16px;
    cursor: pointer;
  }
  .notification_body {
    position: absolute;
    left: 10px;
    right: 10px;
    border-radius: 8px;
    padding: 0;
    max-width: 400px;
    max-height: 400px;
    overflow-y: auto;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    box-shadow: 0px 8px 24px rgba(75, 30, 120, 0.15);
    z-index: 199;
    .noti_header {
      position: sticky;
      top: 0;
      padding: 8px 14px;
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_11};
      border-radius: 12px 12px 0 0;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      display: flex;
      align-items: center;
      gap: 6px;
    }
    .noti_empty {
      padding: 32px 16px;
      text-align: center;
      color: ${({ theme }) => theme.COLORS.GRAY_3};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
    .noti_item {
      padding: 12px 16px;
      cursor: pointer;
      transition: background 0.15s ease;
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_11};
      &:hover {
        background: ${({ theme }) => theme.COLORS.PURPLE_3};
      }
      &:last-child {
        border-bottom: 0;
        border-radius: 0 0 12px 12px;
      }
      .noti_title {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
        margin-bottom: 4px;
      }
      .noti_description {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        color: ${({ theme }) => theme.COLORS.GRAY_16};
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
        line-height: 1.5;
      }
    }
  }
`;
